module.exports = __webpack_public_path__ + "img/0Q3A2496_Mockup.c7d4f437.jpg";